import { Routes } from '@angular/router';

import { AuthenticatedGuard } from './core/guard/authenticated/authenticated-guard';
import { AppLayout } from './shared/layout/app-layout/app-layout';
import { FEEDLOT_ROUTES } from './features/feedlot/feedlot.routes';
import { FARM_ROUTES } from './features/farm/farm.routes';
import { ORTHOPHOTO_ROUTES } from './features/orthophoto/orthophoto.routes';
import { USER_ROUTES } from './features/user/user.routes';
import { DEV_ROUTES } from './features/dev/dev.routes';
import { HELP_ROUTES } from './features/help/help.routes';
import { ENTRADA_SAIDA_ROUTES } from './features/entrada-saida/entrada-saida.routes';
import { MORTALIDADE_ROUTES } from './features/mortalidade/mortalidade.routes';
import { PESO_MEDIO_ROUTES } from './features/peso-medio/peso-medio.routes';
import { RESULTADOS_ROUTES } from './features/resultados/resultados.routes';
import { LOGIN_ROUTES } from './features/login/login.routes';
import { STATUS_FARM_ROUTES } from './features/status-farm/status-farm.routes';
import { WELCOME_ROUTES } from './features/welcome/welcome.routes';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	...LOGIN_ROUTES,
	{
		path: 'main',
		component: AppLayout,
		canActivate: [AuthenticatedGuard],
		children: [
			{ path: '', redirectTo: 'welcome', pathMatch: 'full' },
			...WELCOME_ROUTES,
			...STATUS_FARM_ROUTES,
			...RESULTADOS_ROUTES,
			...ENTRADA_SAIDA_ROUTES,
			...MORTALIDADE_ROUTES,
			...PESO_MEDIO_ROUTES,
			...USER_ROUTES,
			...FARM_ROUTES,
			...FEEDLOT_ROUTES,
			...ORTHOPHOTO_ROUTES,
			...HELP_ROUTES,
			...DEV_ROUTES,
		],
	},
];
